import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

export const ActionButtons = ({options, onSelectOption, showBar, layout = 'floating'}) => {
  const {t} = useTranslation();

  const optionLabelByType = {
    approve: t('chatsocket.buttons.approve'),
    approve_strategy: t('chatsocket.buttons.approve_strategy'),
    approve_arts: t('chatsocket.buttons.approve_arts'),
    edit: t('chatsocket.buttons.edit'),
    batch_edit: t('chatsocket.buttons.batch_edit'),
    reject: t('chatsocket.buttons.reject'),
    select_plan: t('chatsocket.buttons.select_plan'),
    new_campaign: t('chatsocket.buttons.new_campaign'),
    MOCK_SELECT_PLAN: t('chatsocket.buttons.select_plan'),
    MOCK_NEW_CAMPAIGN: t('chatsocket.buttons.new_campaign'),
    MOCK_REGERAR_AGORA: t('chatsocket.buttons.regenerate_from_scratch'),
    mock_retry_campaign: t('chatsocket.buttons.restart_campaign'),
    confirm_batch_edit: t('chatsocket.buttons.confirm'),
    cancel_batch_edit: t('chatsocket.buttons.cancel'),
    MOCK_CONFIRM_BATCH_EDIT_ART: t('chatsocket.buttons.confirm'),
    MOCK_CANCEL_BATCH_EDIT_ART: t('chatsocket.buttons.cancel'),
  };

  const getOptionLabel = (option) => optionLabelByType[option?.type] || option?.name || '';

  const getButtonClassName = (option) => {
    const baseClass = styles.optionButton;
    const disabledClass = option.disabled ? ` ${styles.optionButtonDisabled}` : '';
    const optionLabel = getOptionLabel(option);

    if (
      option.type === 'approve' ||
      option.type === 'approve_strategy' ||
      option.type === 'approve_arts'
    ) {
      return `${baseClass} ${styles.optionButtonApprove}${disabledClass}`;
    } else if (option.type === 'edit' || option.type === 'batch_edit') {
      return `${baseClass} ${styles.optionButtonEdit}${disabledClass}`;
    } else if (option.type === 'reject') {
      return `${baseClass} ${styles.optionButtonReject}${disabledClass}`;
    }

    // Campaign completion buttons
    const primaryCampaignButtons = [
      t('chatsocket.buttons.select_plan'),
      t('chatsocket.buttons.new_campaign'),
    ];
    if (
      option.type === 'select_plan' ||
      option.type === 'new_campaign' ||
      option.type === 'MOCK_SELECT_PLAN' ||
      option.type === 'MOCK_NEW_CAMPAIGN' ||
      primaryCampaignButtons.includes(optionLabel)
    ) {
      return `${baseClass} ${styles.optionButtonPrimary}${disabledClass}`;
    }

    if (
      optionLabel === t('chatsocket.buttons.finalize') ||
      optionLabel === t('chatsocket.buttons.finalize_campaign')
    ) {
      return `${baseClass} ${styles.optionButtonSecondary}${disabledClass}`;
    }

    return `${baseClass}${disabledClass}`;
  };

  const containerClass =
    layout === 'inline'
      ? styles.optionsButtonsContainerInline
      : showBar
        ? styles.optionsButtonsContainerEdit
        : styles.optionsButtonsContainer;

  return (
    <div className={containerClass}>
      {options.map((option, index) => {
        const optionLabel = getOptionLabel(option);
        const buttonTitle = option.disabled
          ? option.disabledReason || option.disabledTitle || optionLabel
          : option.title || optionLabel;

        return (
          <button
            key={index}
            type="button"
            className={getButtonClassName(option)}
            onClick={() => {
              if (option.disabled) {
                return;
              }

              onSelectOption(optionLabel, option.type);
            }}
            disabled={!!option.disabled}
            title={buttonTitle}
          >
            {optionLabel}
          </button>
        );
      })}
    </div>
  );
};

/** @deprecated Use ActionButtons — alias for ChatSocket legacy imports */
export const OptionsButtons = ActionButtons;
